// extracted by mini-css-extract-plugin
export default {"page":"IncompleteProfilePage_page__KLt5i","head":"IncompleteProfilePage_head__PRoXu","body":"IncompleteProfilePage_body__jPTiI"};